import $ from 'jquery';
// import { breakpoints } from './_site';

export const binds = () => {
    $('#wrapper').on('click.print', '[data-print]', function (event) {
        window.print();
        event.preventDefault();
    });
    $('#print-order').on('click', function () {
        $('#order-calculation-section').hide();
        $('#order-freight-career-section').show();
        window.print();
        $('#order-calculation-section').show();
        $('#order-freight-career-section').hide();
    });
};
